import * as React from 'react';
import Privacy from '../containers/Privacy';

export default (props) => (<Privacy {...props} />);
